import { keepPreviousData } from "@tanstack/react-query";
import omit from "lodash/omit";
import uniq from "lodash/uniq";
import { CHAT_NOTIFICATION_CATEGORIES } from "PFApp/constants/notifications";
import { useNotifications } from "PFCore/hooks/queries/notifications/use_notifications";

import { useNotificationsPanelContext } from "../contexts/notifications_panel_context";

export const useNotificationsMetadata = () => {
  const { engagement, role, categories, showUnreadOnly, showImportantOnly } = useNotificationsPanelContext();

  const params = {
    page: 1,
    perPage: 0,
    read: showUnreadOnly ? false : undefined,
    important: showImportantOnly ? true : undefined,
    categories: categories.length ? categories : undefined,
    excludedCategories: CHAT_NOTIFICATION_CATEGORIES,
    engagementId: engagement ? Number(engagement?.id) : undefined,
    roleId: role ? Number(role?.id) : undefined
  };

  const { data: totalUnread } = useNotifications<number>(params, {
    placeholderData: keepPreviousData,
    select: (data) => data?.meta?.totalUnread ?? 0
  });
  const { data: availableCategories } = useNotifications<string[]>(omit(params, "categories"), {
    placeholderData: keepPreviousData,
    select: (data) => uniq([...(data?.meta?.availableCategories ?? []), ...categories])
  });

  return { totalUnread, availableCategories };
};
